module.exports = "/images/checkbox-rounded-unchecked.svg?cbf0a328ef73791f087d1159c72643b9";